import { axios } from 'api'

const getUserActionsCount = (fromDate?: string, toDate?: string) =>
  axios.get('/user-action/count', {
    params: { fromDate, toDate }
  })

const getUserActionsByPaginationAndDate = (
  pageSize: number,
  pageNumber: number,
  fromDate?: string,
  toDate?: string
) =>
  axios.get('/user-action/pagination-date', {
    params: { pageSize, pageNumber, fromDate, toDate }
  })

const downloadUserActionsExcel = (fromDate?: string, toDate?: string) =>
  axios.get('/user-action/download', {
    params: { fromDate, toDate },
    responseType: 'blob'
  })

export {
  getUserActionsCount,
  getUserActionsByPaginationAndDate,
  downloadUserActionsExcel
}
